<template lang="pug">
  .asp-statistics
    h2.primary--text Statistiken

    v-form(ref="filter-form" lazy-validation @submit.prevent="() => {}"): v-row.align-center.mt-5
      v-col.order-3.order-md-0(cols="12" sm="6" md="4")
        v-switch.toggle-cumulated(
          v-model="showCumulated"
          label="Kummulierte Werte"
        )

      v-col.order-0.order-md-1(cols="12" sm="6" md="2")
        n-date-picker(
          v-model="dateFrom"
          label="Datum von"
          format="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
          :input-rules="[ rules.required, rules.valid_date('') ]"
        )

      v-col.order-1.order-md-2(cols="12" sm="6" md="2")
        n-date-picker(
          v-model="dateTo"
          label="Datum bis"
          format="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
          :input-rules="[ rules.required, rules.valid_date('') ]"
        )

      //- v-col(cols="12" sm="6" md="3")
      //-   v-select(
      //-     v-model="destinationGroups"
      //-     label="Nutzergruppe"
      //-     dense
      //-     outlined
      //-     :items="groupOptions"
      //-     :rules="[ rules.required ]"
      //-   )

      v-col.order-2.order-md-3(cols="12" sm="6" md="4")
        v-btn(color="primary" @click="loadData()") Filtern
        v-btn.ml-2(color="primary" @click="exportData()") Export Excel

    v-row.mt-10.mt-sm-4
      v-col.chart-wrapper(cols="12")
        high-charts.high-charts.mt-4.mt-sm-0(ref="highcharts" :options="chartOptions")

      v-col.d-flex.flex-wrap.align-center.justify-center(cols="12")
        v-checkbox.mx-3(
          v-model="groupAll"
          label="Alle"
          dense
          hide-details
          :readonly="!group12 && !group17 && !group33"
          @change="onSelectAll"
        )

        v-checkbox.mx-3(
          v-model="group12"
          label="Gebietsdirektionen VKB"
          dense
          hide-details
          @change="onSelectOne"
        )

        v-checkbox.mx-3(
          v-model="group17"
          label="Agenturvertrieb AgV VKB"
          dense
          hide-details
          @change="onSelectOne"
        )

        v-checkbox.mx-3(
          v-model="group33"
          label="Landesbrand VKB"
          dense
          hide-details
          @change="onSelectOne"
        )

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Chart } from 'highcharts-vue'
import moment from 'moment'

import { downloadBlob, getFileNameFromHeader } from '@/utils/download'
import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    HighCharts: Chart
  }
})
export default class Statistics extends Vue {
  dateFrom = ''
  dateTo = ''
  chartData = {}
  showCumulated = false

  groupAll = true
  group12 = false
  group17 = false
  group33 = false

  groupOptions = [
    {
      text: 'Alle',
      value: 1,
      groups: []
    },
    {
      text: 'Innendienst',
      value: 2,
      groups: [ 'a', 'f', 'g' ]
    },
    {
      text: 'Innendienst-1',
      value: 3,
      groups: [ 'b', 'c', 'd' ]
    }
  ]

  get chartOptions () {
    const series = [
      {
        name: 'Aufrufe',
        data: [],
        prev_sum: 0,
        lineWidth: 3,
      },
      {
        name: 'Beratungen',
        data: [],
        prev_sum: 0,
        dashStyle: 'LongDashDotDot',
        lineWidth: 3,
      },
      {
        name: 'Kunden',
        data: [],
        prev_sum: 0,
        dashStyle: 'LongDashDot',
        lineWidth: 3,
      },
      {
        name: 'Konzepte',
        data: [],
        dashStyle: 'DashDot',
        lineWidth: 3,
        prev_sum: 0,
        color: '#ee7600'
      },
      {
        name: 'Light',
        data: [],
        dashStyle: 'DashDot',
        lineWidth: 3,
        prev_sum: 0,
        color: '#ff76ff'
      }
    ]

    let xMin = 0

    Object.keys(this.chartData || {})
      .sort((a, b) => a > b ? 1 : -1)
      .forEach(k => {
        const timestamp = moment.utc(k.substring(0, 10)).valueOf()
        if (!xMin) {
          xMin = timestamp
        }

        ([ 'count_users', 'count_consultations', 'count_companies', 'count_konzept', 'count_light' ]).forEach((f, i) => {
          series[i].data.push([
            timestamp,
            this.chartData[k][f] + series[i].prev_sum
          ])

          if (this.showCumulated) {
            series[i].prev_sum += this.chartData[k][f]
          }
        })
      })

    return {
      title: {
        text: 'Entwicklung RiMaS'
      },

      credits: {
        enabled: false
      },

      exporting: {
        csv: {
          dateFormat: '%d.%m.%Y',
          columnHeaderFormatter: function (item) {
            return item.coll === 'xAxis'
              ? 'Datum'
              : item.name
          }
        },

        // buttons: {
        //   contextButton: {
        //     menuItems: [
        //       {
        //         textKey: 'downloadCSV',
        //         onclick: function () {
        //           this.downloadCSV()
        //         }
        //       }
        //     ]
        //   }
        // }
      },

      yAxis: {
        title: {
          text: ''
        }
      },

      xAxis: {
        type: 'datetime',
        labels: {
          formatter () {
            return moment(this.value, 'x').format('DD.MM.YYYY')
          }
        },
        min: xMin,
        showEmpty: true,
        startOnTick: true,
        tickInterval: 24 * 3600 * 1000, // 1 day
      },

      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },

      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: 2010
        }
      },

      tooltip: {
        headerFormat: '',
        pointFormatter: function () {
          let header = `<b>Datum: </b>${ moment(this.x).format('DD.MM.YYYY') }`
          return `${ header }<br><b>${ this.series.name }: </b>${ this.y }`
        }
      },

      series
    }
  }

  created () {
    this.dateTo = this.formatDateTime(new Date())
    this.dateFrom = this.getDateFromOffset(this.dateTo, -30)
    // this.destinationGroups = 1
    this.loadData(true)
  }

  exportData () {
    // const { chart } = this.$refs.highcharts
    // chart.downloadCSV()
    const groups = [] // this.groupOptions.find(g => g.value === this.destinationGroups)

    if (this.group12) {
      groups.push('12')
    }

    if (this.group17) {
      groups.push('17')
    }

    if (this.group33) {
      groups.push('33')
    }

    const params = {
      date_from: this.dateFrom,
      date_to: this.dateTo,
      destination_groups: groups
    }

    this.$axios
      .fetchFile(Urls.StatisticsExport, params, 'POST')
      .then(async (res) => {
        const blob = await res.blob()
        return {
          blob,
          headers: res.headers
        }
      })
      .then(res => {
        downloadBlob(res.blob, getFileNameFromHeader(res.headers, res.headers.get('Content-Disposition')))
      })
      .catch(err => {
        this.$toast.error('Fehler', err.message)
      })
  }

  loadData (isInit = false) {
    if (!isInit && !this.isFormValid('filter-form')) {
      return
    }

    const groups = [] // this.groupOptions.find(g => g.value === this.destinationGroups)

    if (this.group12) {
      groups.push('12')
    }

    if (this.group17) {
      groups.push('17')
    }

    if (this.group33) {
      groups.push('33')
    }

    const params = {
      date_from: this.dateFrom,
      date_to: this.dateTo,
      destination_groups: groups
    }

    this.$axios
      .post(Urls.Statistics(), params)
      .then(res => {
        this.chartData = res.data
      })
      .catch(err => {
        this.$toast.error('Fehler', err.message)
      })
  }

  onSelectAll () {
    if (this.groupAll) {
      this.group12 = false
      this.group17 = false
      this.group33 = false
    }
    this.loadData()
  }

  onSelectOne () {
    this.groupAll = !this.group12 && !this.group17 && !this.group33
    this.loadData()
  }
}
</script>

<style lang="scss">
.chart-wrapper {
  position: relative;

  .high-charts {
    height: calc(100vh - 400px);
  }
}
</style>
